module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowPage"
  }, [_c('div', {
    staticClass: "title-acknowPage"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781466826052_toc01#toctitle1",
      "id": "title1"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ACKNOWLEDGMENTS")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This book would have been impossible without the help of many, many people. Thanks go first to Lou Anders, whose anthology evoked the universe. Also thanks to Gardner Dozois and Sheila Williams for giving Strom’s story a home. The Blue Heaven writers group helped me perfect the thing. My agent, Caitlin Blasdell, provided crucial advice and guidance. David Hartwell and Denis Wong at Tor turned some scraps of paper into a book. There are others, I know, who helped too. Thank you. Lastly, extra special thanks to my wife, Stacey, who puts up with my daydreaming and distraction. (See? I wasn’t ignoring you; I was working.)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13f90746","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781466826052_ack01.vue
// module id = 72
// module chunks = 0